<template>
  <div class="project">
    <div class="name">{{ name }}</div>
    <div class="url">{{ url }}</div>
    <div class="description">
      <p v-for="(fragment, i) in descriptionMarkup"
         :key="i"
         class="md"
         v-html="fragment"></p>
    </div>
    <div class="launch">Launched <span class="launch_date">{{launchDate}}</span></div>
  </div>
</template>

<script>

import MarkdownMixin from '@/mixins/markdown';

export default {
    name   : "Project",
    mixins : [ MarkdownMixin ],
    props  : {
        model : {
            type : Object
        }
    },
    computed : {
        name() {
            return this.model.name;
        },
        description() {
            return this.model.description;
        },
        descriptionMarkup() {
            return this.description.map(text => {
                return this.markdown.renderInline(text.trim());
            });
        },
        launchDate() {
            return this.model.launchDate;
        },
        url() {
            return this.model.url;
        }
    }
};

</script>

<style scoped>

.project {
    padding-bottom:80px;
}

.project .name {
    font-size:18px;
    font-weight:bold;
}

.project .description {
    font-size:14px;
    padding:1.25em 0em;
}

.project .launch {
    font-size:12px;
    font-style:italic;
}

.project .url {
    font-size:14px;
    font-style:italic;
    color:#666666;
}

</style>
